/**
 * Quiz tracking based on URL parameters
 * Detects when quiz is opened via aidenSidebar parameter
 */

import { trackQuizOpened } from './events.js';

/**
 * Initialize quiz tracking
 */
export function initQuizTracking() {
    // Track quiz opening if parameter is present on page load
    checkForQuizParameter();
    
    // Listen for URL changes
    monitorUrlChanges();
    
    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', checkForQuizParameter);
}

/**
 * Check if quiz parameter is present and track accordingly
 */
function checkForQuizParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('aidenSidebar')) {
        trackQuizOpened({
            referrer: document.referrer,
            quizType: 'aiden',
        });
    }
}

/**
 * Monitor URL changes for SPA-like behavior
 */
function monitorUrlChanges() {
    let currentUrl = window.location.href;
    let hasTrackedQuiz = false;
    
    // Reset tracking flag when URL changes
    const resetTrackingFlag = () => {
        const newUrl = window.location.href;
        if (newUrl !== currentUrl) {
            currentUrl = newUrl;
            hasTrackedQuiz = false;
        }
    };
    
    // Check for quiz parameter periodically
    setInterval(() => {
        resetTrackingFlag();
        
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('aidenSidebar') && !hasTrackedQuiz) {
            trackQuizOpened({
                referrer: document.referrer,
                quizType: 'aiden',
            });
            hasTrackedQuiz = true;
        }
    }, 500); // Check every 500ms
}

/**
 * Manual trigger for quiz tracking (if needed by other components)
 * @param {string} quizType - Type of quiz being opened
 */
export function triggerQuizTracking(quizType = 'aiden') {
    trackQuizOpened({
        referrer: document.referrer,
        quizType,
    });
}